import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fa7ab4be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "/assets/dinbook-white.png"
}, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sentToKitchen" }
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20,2H4C2.9,2,2,2.9,2,4v18l4-4h14c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M13.57,11.57L12,15l-1.57-3.43L7,10l3.43-1.57 L12,5l1.57,3.43L17,10L13.57,11.57z" })
], -1))
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, [
  /*#__PURE__*/_createElementVNode("span", null, "o")
], -1))
const _hoisted_11 = { class: "payOrderText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_payments_summary_card = _resolveComponent("payments-summary-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      (_ctx.paymentInfo)
        ? (_openBlock(), _createBlock(_component_ion_content, {
            key: 0,
            class: "padding",
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                (_ctx.paymentInfo.paid || _ctx.paymentInfo.payment_type == null)
                  ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.$t("confirmation.successMsg")), 1))
                  : _createCommentVNode("", true),
                (_ctx.paymentInfo.paid || _ctx.paymentInfo.payment_type === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("confirmation.sentToKitchen")), 1),
                      (_ctx.paymentInfo.reviews_link !== null && _ctx.paymentInfo.reviews_link !== '')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn-review",
                            href: _ctx.paymentInfo.reviews_link,
                            target: "_blank"
                          }, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("confirmation.review")), 1)
                          ], 8, _hoisted_6))
                        : _createCommentVNode("", true),
                      (_ctx.paymentInfo.payment_type !== null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.newOrder && _ctx.newOrder(...args)))
                          }, _toDisplayString(_ctx.$t("confirmation.newOrder")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.paymentInfo.paid)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openEmailTicketDialog && _ctx.openEmailTicketDialog(...args)))
                          }, _toDisplayString(_ctx.$t("confirmation.sentByEmail")), 1))
                        : _createCommentVNode("", true),
                      (_ctx.paymentInfo.payment_type === null)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 3,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.continueOrder && _ctx.continueOrder(...args)))
                          }, _toDisplayString(_ctx.$t("confirmation.continueOrder")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.paymentInfo.paid && _ctx.paymentInfo.payment_type !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.$t("confirmation.remaining", { amount: _ctx.$filters.currency(_ctx.paymentInfo.total - _ctx.paymentInfo.total_paid) })), 1),
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.payAnother && _ctx.payAnother(...args)))
                      }, _toDisplayString(_ctx.$t("confirmation.payAnotherPart")), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_payments_summary_card),
                (!_ctx.paymentInfo.paid && _ctx.paymentInfo.payment_type === null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("span", _hoisted_11, [
                        _createTextVNode(_toDisplayString(_ctx.$t("confirmation.payOrder")) + ": ", 1),
                        _createElementVNode("b", null, _toDisplayString(_ctx.$filters.currency(_ctx.paymentInfo.total -
            _ctx.paymentInfo.total_paid)), 1)
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.payAnother && _ctx.payAnother(...args)))
                      }, _toDisplayString(_ctx.$t("confirmation.goToPayment")), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}